import { PRODUCTS_DATA_API, PRODUCTS_DATA_LOCAL } from '@models/productFirebaseModels';
import { db } from '@config/firebaseConfig';
import { collection, getDocs } from "firebase/firestore";

/**
 * It retrieves the product list from an external API or a local file.
 */

// CONFIGURATION: true for Firebase, false for Local Data
const USE_FIREBASE = false;

const productsCollection = collection(db, "products");

/**
 * Fetches products from Firebase or the Local file depending on the configuration.
 */
export const getProducts = async () => {
    // CASE 1: Local Data
    if (!USE_FIREBASE) {
        console.log("Loading data from: LOCAL");
        return PRODUCTS_DATA_LOCAL.map(item => new PRODUCTS_DATA_API(item));
    }

    try {
        console.log("Loading data from: FIREBASE");
        const querySnapshot = await getDocs(productsCollection);

        return querySnapshot.docs.map(doc => {
            const data = { id: doc.id, ...doc.data() };
            return new PRODUCTS_DATA_API(data);
        });
    } catch (error) {
        console.error("Error fetching products from Firebase:", error);
        // Fallback to local data in case of error
        return PRODUCTS_DATA_LOCAL.map(item => new PRODUCTS_DATA_API(item));
    }
};